"use client";
import { MAIN_ID } from "@/components/main-id";
import { useT } from "@/i18n/react";

/**
 * "Skip to main content" (WCAG 2.4.1): the first focusable element of every page. Hidden until it takes
 * focus, then drawn above the fixed header. Its target is the page's `<Main>`.
 */
export function SkipLink() {
    const t = useT();
    return (
        <a
            href={`#${MAIN_ID}`}
            className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[100] focus:rounded-md focus:bg-primary focus:px-4 focus:py-2 focus:text-sm focus:font-medium focus:text-primary-foreground focus:shadow-lg"
        >
            {t("shell.skipToMain")}
        </a>
    );
}

export default SkipLink;
